import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const babyNotFollowing: BlogMetaData = {
  title: '赤ちゃんが後追いしないのは大丈夫？原因と対処法をモンテッソーリ視点で解説',
  description:
    '赤ちゃんが後追いしないと不安になりますよね。個人差がある理由や発達への影響の考え方、今日からできる愛着を育む関わり方までモンテッソーリの視点でやさしく解説します。',
  thumbnailUrl: '/img/blog-baby-not-following.webp',
  filePath: buildBlogFilePath('baby-not-following'),
  category: BLOG_CATEGORY.PARENTING,
};
